import { Languages } from "src/common/descriptions/types";
import { CreateIncomeRecordDescriptions } from "./types";

const DescriptionsEnUs: CreateIncomeRecordDescriptions = {
    TITLE: "Create Cashbox Income Record",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save Record?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Record input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Record Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Record Updated",
    },
    FORM: {
        DESCRIPTION: {
            LABEL: "Description",
            PLACEHOLDER: "Input description",
        },
        TOTAL: {
            LABEL: "Total",
            PLACEHOLDER: "0.00",
        },
        IS_LOAN: {
            LABEL: "Register Loan",
            PLACEHOLDER: "Register income as loan",
        },
    },
    MAIN_ACTION_TITLE: "Creating Record",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    LOAN_WARNING: "This income will be registered as a loan. A non-monthly Payable Contract will be created to reflect this loan in the system.",
    LOAN_WARNING_TITLE: "Warning",
}

const DescriptionsEsUs: CreateIncomeRecordDescriptions = {
    TITLE: "Crear Registro de Ingreso a Caja",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Registro con los datos ingresados?',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Registro?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Regisro creado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Registro Actualizado",
    },
    FORM: {
        DESCRIPTION: {
            LABEL: "Descripción",
            PLACEHOLDER: "Ingresa descripción",
        },
        TOTAL: {
            LABEL: "Total",
            PLACEHOLDER: "0.00",
        },
        IS_LOAN: {
            LABEL: "Registrar Préstamo",
            PLACEHOLDER: "Registrar ingreso como préstamo",
        },
    },
    MAIN_ACTION_TITLE: "Creando Registro",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    LOAN_WARNING: "Este ingreso será registrado como un préstamo. Se creará un Contrato por Pagar no mensual para reflejar este préstamo en el sistema.",
    LOAN_WARNING_TITLE: "Atención",
}

export const createIncomeRecordDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}